// apps/web/src/lib/razorpay.ts
let loaded = false

export interface RazorpayHandlerResponse {
  razorpay_order_id: string
  razorpay_payment_id: string
  razorpay_signature: string
}

export interface RazorpayOptions {
  amount: number
  currency: string
  description?: string
  handler: (response: RazorpayHandlerResponse) => void
  key: string
  modal?: { ondismiss?: () => void }
  name: string
  order_id: string
  prefill?: { contact?: string; email?: string }
  theme?: { color?: string }
}

export function loadRazorpay(): Promise<boolean> {
  if (loaded) return Promise.resolve(true)
  return new Promise((resolve) => {
    const script = document.createElement('script')
    script.src = 'https://checkout.razorpay.com/v1/checkout.js'
    script.onload = () => {
      loaded = true
      resolve(true)
    }
    script.onerror = () => resolve(false)
    document.body.appendChild(script)
  })
}

declare global {
  interface Window {
    Razorpay: new (options: RazorpayOptions) => { open: () => void }
  }
}
